import { configureStore } from "@reduxjs/toolkit";
import { cropToolSlice } from "../classes/cropTool";
import { rotToolSlice } from "../classes/rotTool";
import { perpToolSlice } from "../classes/perpTool";
import { filterToolSlice } from "../classes/median";
import { scaleToolSlice } from "../classes/scale";
export default configureStore(
    {
        reducer: {
            cropTool: cropToolSlice.reducer,
            rotTool: rotToolSlice.reducer,
            perpTool: perpToolSlice.reducer,
            filterTool: filterToolSlice.reducer,
            scaleTool: scaleToolSlice.reducer,
        },
    },
)